const us = {
  common: {
    smartPhoneOrder: 'Mobile Order',
    seatNumber: 'Table No.',
    orderIsNowAvailableWithASmartphone: 'Order is now available with a smartphone.',
    readTheQrCodeAgainAfterClosingTheApp: 'Read the QR code again after closing the app.',
    orderWithOtherSmartphones: 'Order with other smartphones.',
    youCouldOrderWithOtherSmartphonesByReadingTheQrCodeShownOnThisPhone:
      'You could order with other smartphones by reading the QR code shown on this phone.',
    showTheQrCode: 'Show the QR code',
    youCouldOrderWithAMaximumOf6Smartphones: 'You could order with a maximum of 6 smartphones.',
    close: 'Close',
    howToUse: 'How to use',
    doNotDisplayThisDialogAgain: 'Do not display this dialog again.',
    todaysSpecialMenu: "Today's Special Menu",
    cancel: 'Cancel',
    numberBefore: 'No.',
    numberAfter: '',
    finishedDishes: 'Inserted Plates',
    dishes: 'Plates',
    call: 'Help',
    check: 'Checkout',
    home: 'Menu',
    search: 'Search',
    return: 'Back',
    pleaseWaitTheEmployeeWillArriveShortly:
      'Please wait,\nthe employee will arrive shortly.\nPlease stay on this screen, thank you.',
    cancelTheCall: 'Cancel the Call',
    orderWithOtherCustomersSmartphone: "Order with other customer's smartphone.",
    order: 'Order',
    yes: 'Yes',
    no: 'No',
    end: 'Done',
    putIn: 'All Plates Inserted',
    staffCalling: 'Help',
    smartphoneOrderSuccess: 'Finish Mobile Orders',
    certification: 'Processing',
    pleaseWait: 'Please Wait',
    busyTimes: 'It may take some time to switch screens\nduring busy times.',
    scanTheQRCodeAgain: 'If the screen does not switch,\nplease scan the QR code again.',
    recommendMenu: 'Recommended Menu',
    callStaff: 'Help',
    cancelCall: 'Cancel',
    yen: 'yen',
    twGen: 'NTD',
    cnGen: 'CNY',
    dollar: '${price}',
    calorieUnit: 'Cal',
  },
  welcome: {
    smartPhoneOrderDescription:
      'This service enables ordering from your mobile device by scanning the QR code.',
    availableShopList: 'Restaurant list with mobile orders.',
    operationMethod: 'Tutorial',
    alreadyInstalledApp: 'Guest with Kura Mobile App installed.',
    alreadyInstalledAppDescription:
      'Scan the QR code by activating the camera from the mobile app.',
    notInstalledApp: 'Guest without Kura Mobile App.',
    notInstalledAppDescription:
      'Please activate the camera on your mobile device and scan the QR code.',
  },
  preOrder: {
    'pre-orderConfirm': 'Send Pre-Ordered Item',
    pleaseReadTheQrCodeAfterTheGuidance: 'Please scan the QR code when seated.',
    'thePre-orderingMenuIs10ForMaximum': 'The pre-ordering menu is 10 for maximum.',
    appointmentNumber: 'Reserve No.',
    comfirming: 'Processing',
    shop: 'Restaurant',
    receptionNumber: 'Guest Number',
    reservationUsherTime: 'Estimated Seating Time',
    numberOfReservations: 'Number of Party',
    preOrder: 'Pre-Order',
    preOrderhowToUseDescription:
      'Send the order\nby pressing the red button\nand scanning the QR code.',
    soldOutDescription: 'Out of stock item will be unavailable.',
    preOrderLimitOver:
      'Exceeded the pre-order limit.\nThe limit will be cleared once you are seated at a table.',
  },
  sideMenu: {
    settings: 'Settings',
    menuAppearance: 'Menu Display',
    menuLarge: 'Large',
    menuSmall: 'Small',
    languageSettings: 'Language Settings',
    showTheQrCodeAuthenticationForConnectingWithOtherSmartphones:
      'Show the QR code authentication for connecting with other smartphones.',
    closeTheOrderScreenWithTheSmartphone: 'Close Mobile Order',
    regardingSmartPhoneOrder: 'About Mobile Order',
    showAllergenInformation: 'Show allergen information',
  },
  orderHistory: {
    orderHistoryOfThisWholeTableWillBeDisplayed:
      'All order history of this table will be displayed.',
    orderHistory: 'Order History',
    todaysOrderHistory: "Today's Order History",
    arrived: 'Delivered',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-prefix':
      'Ordered items prior to your last visit will be displayed.',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-suffix': 'Piece',
    orderFromSmartphone: 'Mobile Order Items',
    arriveComplete: 'arrived',
    orderPending: 'Busy',
    pastOrderHistory: 'Past Order History',
    pastOrderHistoryDescription: '※The latest 100 order history will be displayed.',
  },
  search: {
    searchCandidates: 'Frequently Searched Items',
    searchDescription: 'Enter a keyword for related items to show up.',
    searchResultBefore: 'Search Result of',
    searchResultAfter: '',
    listening: 'Voice Function Enabled',
  },
  howToUse: {
    howToOrderWithTheSmartphone: 'How to order with the smartphone.',
    canOrderWithSmartPhone: 'Guest can order from a mobile device.',
    sideMenuAlsoCanMakeBikkuraPon: 'Bikkura Pon can also be enjoyed with side dishes.',
    canCompleteOrderBeforeMeal: 'Guest can decide on order items before seating at a table.',
    preOrderAfterReserved:
      'Pre-order is enabled once the reservation is confirmed.\n Pre-ordered items will be activated once the QR code is scanned from the touch screen.',
    noLimitForOrder: 'Multiple guests can order from multiple devices per table.',
    scanQrAndStart: 'Guest can place an order from the mobile device after scanning the QR code.',
  },
  order: {
    thankYouForYourOrder: 'Thank you for your order.',
    theOrderHasBeenReceived: 'The order has been received.',
    arrangeOfSpecialAndPopularMenu: 'Recommended Menu',
    cancelTheCheck: 'Cancel the Check',
    orderCancelConfirmation: 'Do you want to cancel your order?',
    pleaseWait: 'Please Wait',
    pleaseCheckout: 'Please checkout on the touch screen.',
    checkCancelDescription: 'To cancel,\nplease use the touch screen.',
    checkCancelDescriptionUs: 'To cancel,\nclick on the back button on the touch screen.',
    endOrder: 'Finish Mobile Order',
    askEndOrder: 'End order.Continue?',
    endOrderConfirmation: 'Do you want to finish the mobile order?',
    endOrderAttention:
      'If no other mobile devices are connected to mobile order, order history from today will be deleted.\nDo you want to continue?',
    endSession: 'Session disconnected.\nMobile order will be closed.',
  },
  bikkuraPon: {
    'bikkura-pon': 'Side Menu Bikkura Pon',
    'bikkura-pon-jp': 'Smartphone Bikkura Pon',
    smartPhoneOrderLimited: 'Limited on Mobile Order',
    bikkuraPonExplanationBefore:
      'Side dishes with this icon qualify for one (1) Bikkura Pon prize after a total of',
    bikkuraPonExplanationAfter:
      'ordered through mobile device.\nMobile orders on the same table are combined.\nYour Bikkura Pon meter will fill up once your item arrives!',
    startBikkuraPon: 'Start Bikkura Pon.',
    howToStartBikkuraPon: 'Press here\nto start Bikkura Pon.',
    pressToStartBikkuraPon: 'Press here\nto start Bikkura Pon.',
    bikkuraPonConfirmation: 'Do you want to play Bikkura Pon?',
    remainingTimes: '{count} Bikkura Pon(s) remaining!',
    start: 'Start',
    bikkuraPonUnabled: 'Unable to proceed to Bikkura Pon.',
    drawingFailure:
      'Unable to proceed to Bikkura Pon.\nPlease check the network status and remaining spins.',
    bikkuraPonInProgress: 'Bikkura Pon in progress.',
    bikkuraPonInProgressDescription: 'Bikkura Pon in progress.\nPlease try again later.',
    congratulations: 'Congratulations.',
    lose: 'Sorry.',
  },
  present: {
    arrivedPresent: 'You have received a gift from Kura Sushi.',
    cannotCancelOperation: '※Cannot cancel operation',
    notReceive: 'Reject',
    receive: 'Receive',
  },
  textInImage: {
    waitingArea: 'Waiting Area',
    jackpot: 'Jackpot',
    lose: 'Lose.',
    numberPlate: 'Table Guide',
  },
  error: {
    oparateFromTouchPanel: 'Please use the touch screen.',
    networkError: 'Network Error',
    failedToProcess: 'Processing failed.',
    notFound: 'Page does not exist.',
    notFoundOrRemoved: 'Page does not exist or has been deleted.',
    operatingAgainOnTopPage: 'Please try again from the top page of Mobile Order.',
    backToTop: 'Return to main menu.',
    limitErrorDescription: 'Sorry.Order has reached the limit.Please try again later.',
    orderStopErrorDescription: 'Sorry.Order has reached the limit.Please try again later.',
    stockoutErrorDescription: 'Sorry, this item is out of stock.',
    orderError: 'Please try again later.\nPlease ask the staff for help if the problem persists.',
    unableToAuthenticate: 'Unable to Authenticate',
    failureToAuthorization: 'Authentication failed ',
    systemError: 'System error',
    unknownError: 'Unknown error',
    unknownErrorDescription: 'An unexpected error occurred and the app has stopped working',
    pleaseReload: 'Sorry, please reload your browser',
    reload: 'Reloading',
  },
  selfcheck: {
    comfirmNumbers: 'Guest number confirmation.',
    singleSeatCheckOut: 'Checking out solo?',
    multiSeatsCheckOut:
      'To combine the tables for checkout,\nplease press NO.\nYour server will arrive shortly to assist.',
    dishesConfirm: 'Plates confirmation',
    paymentConfirm: 'amount confirmation',
    sushiPlate: 'Plates',
    redPlate: 'Red Plates',
    buckleSeparate: 'Please separate the ring.',
    putThePlateInThrowingSlot: 'Please insert the plates into the plate slot.',
    accountingConfirmation: 'Please confirm your check.',
    contents: 'Contents',
    quantity: 'Quantity',
    totalAmount: 'Total',
    checkConfirmed: 'Checkout confirmed.',
    takeNumberPlateToTheCounter: 'Please take the number guide\nto the cashier.',
    checking: 'Checking out.',
    waitUntilRedirect: 'Please wait. The screen will redirect once the checkout is confirmed.',
    howToCancelSelfcheck: 'To cancel, please select Cancel on the mobile device or touch screen.',
    checkOutContentHasBeenChanged: 'Checkout detail has changed.',
    pleaseCheckAgain: 'Please check again.',
    closeCheckPageConfirmation: 'Cancel checkout?',
    abortCheckAndBackToMainConfirmation: 'Redirecting to main menu.\nContinue?',
    howToCancelCheckOut: 'To cancel, please use the touch screen.',
    smartphoneOrderFinished: 'Finish Mobile Order.',
    staffComingPleaseWait: 'Please wait for your server to arrive.',
    error: 'Error.',
    failedToLoading: 'Confirmation failed.',
    selfcheckTryAgainApology:
      'Confirmation failed.\nCanceling checkout.\nPlease go back to the main menu and try again.',
    backToMainMenu: 'Back to main menu.',
    selfcheckRestartApology:
      'Processing failed. Back to main menu.\nIf the screen does not redirect, please use the touch screen to continue.',
    selfcheckWaitMomentApology:
      'Checkout failed.\nPlease try again later or call your server for assistance.',
    calling: 'Help.',
    confirming: 'Confirming.',
    useTouchPanel: 'Please press Back on the touch screen and continue.',
  },
  pageTitle: {
    shopMenu: 'Menu',
    order: 'Order',
    ad: 'Recommended Menu',
    adOrder: 'Recommended Menu',
    recommendOrder: 'Recommended Menu',
    history: 'Order History',
    historyOrder: 'Order History',
    search: 'Search',
    searchOrder: 'Search',
  },
  siteId: 'Mobile Order | KURA SUSHI',
}

export default us
